import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import AIData from './pages/AIData';
import Engineering from './pages/Engineering';
import Industries from './pages/Industries';
import TeamAugmentation from './pages/services/TeamAugmentation';
import ITConsulting from './pages/services/ITConsulting';
import CloudServices from './pages/services/CloudServices';
import DevOps from './pages/services/DevOps';
import WebsiteDevelopment from './pages/applications/WebsiteDevelopment';
import MobileDevelopment from './pages/applications/MobileDevelopment';
import GameDevelopment from './pages/applications/GameDevelopment';
import QualityAssurance from './pages/applications/QualityAssurance';
import UIUXDesign from './pages/applications/UIUXDesign';
import DataEngineering from './pages/ai-data/DataEngineering';
import AnalyticsBI from './pages/ai-data/AnalyticsBI';
import AIDevelopment from './pages/ai-data/AIDevelopment';
import GenAI from './pages/ai-data/GenAI';
import Blockchain from './pages/ai-data/Blockchain';
import MLOps from './pages/ai-data/MLOps';
import EmbeddedSystems from './pages/engineering/EmbeddedSystems';
import IoTDevelopment from './pages/engineering/IoTDevelopment';
import MVPDevelopment from './pages/engineering/MVPDevelopment';
import Automotive from './pages/engineering/Automotive';
import Healthcare from './pages/industries/Healthcare';
import FinTech from './pages/industries/FinTech';
import Retail from './pages/industries/Retail';
import Ecommerce from './pages/industries/Ecommerce';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import Careers from './pages/Careers';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/ai-data" element={<AIData />} />
            <Route path="/engineering" element={<Engineering />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/careers" element={<Careers />} />
            
            {/* Services Routes */}
            <Route path="/services/team-augmentation" element={<TeamAugmentation />} />
            <Route path="/services/it-consulting" element={<ITConsulting />} />
            <Route path="/services/cloud-services" element={<CloudServices />} />
            <Route path="/services/devops" element={<DevOps />} />
            
            {/* Applications Routes */}
            <Route path="/applications/website-development" element={<WebsiteDevelopment />} />
            <Route path="/applications/mobile-development" element={<MobileDevelopment />} />
            <Route path="/applications/game-development" element={<GameDevelopment />} />
            <Route path="/applications/quality-assurance" element={<QualityAssurance />} />
            <Route path="/applications/ui-ux-design" element={<UIUXDesign />} />
            
            {/* AI & Data Routes */}
            <Route path="/ai-data/data-engineering" element={<DataEngineering />} />
            <Route path="/ai-data/analytics-bi" element={<AnalyticsBI />} />
            <Route path="/ai-data/ai-development" element={<AIDevelopment />} />
            <Route path="/ai-data/gen-ai" element={<GenAI />} />
            <Route path="/ai-data/blockchain" element={<Blockchain />} />
            <Route path="/ai-data/mlops" element={<MLOps />} />
            
            {/* Engineering Routes */}
            <Route path="/engineering/embedded-systems" element={<EmbeddedSystems />} />
            <Route path="/engineering/iot-development" element={<IoTDevelopment />} />
            <Route path="/engineering/mvp-development" element={<MVPDevelopment />} />
            <Route path="/engineering/automotive" element={<Automotive />} />
            
            {/* Industries Routes */}
            <Route path="/industries/healthcare" element={<Healthcare />} />
            <Route path="/industries/fintech" element={<FinTech />} />
            <Route path="/industries/retail" element={<Retail />} />
            <Route path="/industries/ecommerce" element={<Ecommerce />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 